import React, { useState } from 'react';
import { FiGrid, FiUsers, FiBook, FiUserCheck } from 'react-icons/fi';
import KhoiPage from './KhoiPage';
import LopHocPage from './LopHocPage';
import MonHocPage from './MonHocPage';
import GiaoVienPage from './GiaoVienPage';

const TABS = [
  { key: 'gv',   label: 'Giáo viên', icon: FiUserCheck, color: '#d97706', bg: 'linear-gradient(135deg,#d97706,#b45309)' },
  { key: 'khoi', label: 'Khối học',  icon: FiGrid,      color: '#7c3aed', bg: 'linear-gradient(135deg,#7c3aed,#6d28d9)' },
  { key: 'lop',  label: 'Lớp học',   icon: FiUsers,     color: '#2563eb', bg: 'linear-gradient(135deg,#2563eb,#1d4ed8)' },
  { key: 'mon',  label: 'Môn học',   icon: FiBook,      color: '#059669', bg: 'linear-gradient(135deg,#059669,#047857)' },
];

const DanhMucPage = () => {
  const [activeTab, setActiveTab] = useState('gv');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="danh-muc-tab-bar">
        {TABS.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              className={`danh-muc-tab${isActive ? ' active' : ''}`}
              style={isActive ? { background: tab.bg, '--tab-color': tab.color } : { '--tab-color': tab.color }}
              onClick={() => setActiveTab(tab.key)}
            >
              <Icon size={15} className="danh-muc-tab-icon" />
              <span className="danh-muc-tab-label">{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="danh-muc-tab-content">
        {activeTab === 'khoi' && <KhoiPage />}
        {activeTab === 'lop'  && <LopHocPage />}
        {activeTab === 'mon'  && <MonHocPage />}
        {activeTab === 'gv'   && <GiaoVienPage />}
      </div>

      <style>{`
        .danh-muc-tab-bar {
          display: flex;
          gap: 4px;
          padding: 6px 14px;
          background: linear-gradient(135deg, #1e1b4b 0%, #312e81 60%, #1e40af 100%);
          flex-shrink: 0;
          align-items: center;
          border-bottom: 1px solid rgba(255,255,255,0.08);
        }

        .danh-muc-tab {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 5px 14px;
          height: 34px;
          border: 1px solid rgba(255,255,255,0.15);
          background: rgba(255,255,255,0.06);
          color: rgba(255,255,255,0.6);
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          border-radius: 8px;
          transition: all 0.15s;
          white-space: nowrap;
        }

        .danh-muc-tab:hover:not(.active) {
          background: rgba(255,255,255,0.13);
          color: #fff;
          border-color: rgba(255,255,255,0.25);
        }

        .danh-muc-tab.active {
          color: #fff;
          border-color: transparent;
          font-weight: 700;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        }

        .danh-muc-tab-icon {
          flex-shrink: 0;
          opacity: 0.85;
        }

        .danh-muc-tab-label {
          font-size: 13px;
        }

        .danh-muc-tab-content {
          flex: 1;
          overflow: auto;
        }
      `}</style>
    </div>
  );
};

export default DanhMucPage;
